import React from "react";
import axiosAuth from "../Axios/Interceptors";
import axios from "axios";
import AppContext from "../Context/Context";
import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
function VerifyCR() {
  const [searchParams, setSearchParams] = useSearchParams();
  let query = searchParams.get("q");

  useEffect(() => {
    if (query && query !== null) {
      GetTokenDataFromKey(query);
    }
  }, [query]);

  function GetTokenDataFromKey(query: any) {
    let object = {} as any;
    object.keydt = query;
    axios
      .post(AppContext.AppAuthBaseURL + "api/SiteUser/GetTokenDataFromKey", object)
      .then((response) => {
        if (response.data.Status === 1) {
          var l_response = response.data.Data[0];
          if (
            l_response.RefreshToken &&
            l_response.RefreshToken !== null &&
            l_response.RefreshToken !== ""
          ) {

           // var ReturnURL = AppContext.GetCookie(AppContext.ReturnURL);

          } else {
            //window.location ="https://www.jlrmenabusinesstools.com/login.aspx" as any;
          }
        } else {
         // window.location ="https://www.jlrmenabusinesstools.com/login.aspx" as any;
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  return <>Loading...</>;
}

export default React.memo(VerifyCR);
